import { utils } from '@didi/webx-js'

const WIDTH_ITEM = {
  type: 'NumberInput',
  nullable: false,
  label: '宽度',
  toolTip: '屏幕满宽为750',
}

const HEIGHT_ITEM = {
  type: 'NumberInput',
  nullable: false,
  label: '高度',
  toolTip: '屏幕满高为1334',
}

const MARGIN_TOP_ITEM = {
  type: 'NumberInput',
  nullable: false,
  label: '距离上',
}

const MARGIN_BOTTOM_ITEM = {
  type: 'NumberInput',
  nullable: false,
  label: '距离下',
}

const TOP_ITEM = {
  type: 'NumberInput',
  nullable: false,
  label: '距离顶部',
}

const BG_IMAGE_ITEM = {
  label: '背景图片',
  type: 'MediaInput',
  clearable: true,
  mediaType: 'img',
  needFileName: false,
}

const BG_COLOR_ITEM = {
  type: 'ColorSet',
  label: '背景颜色',
  toolTip: '可设置透明度(A)',
}

const BORDER_RADIUS_ITEM = {
  type: 'NumberInput',
  nullable: false,
  label: '圆角大小',
}

const FONT_SIZE_ITEM = {
  type: 'NumberInput',
  nullable: false,
  label: '字体大小',
}

const COLOR_ITEM = {
  type: 'ColorSet',
  label: '字体颜色',
}

const TEXT_ALIGN_ITEM = {
  type: 'RadioGroup',
  label: '文本对齐',
  options: [
    {
      label: '居中',
      value: 'center',
    },
    {
      label: '居左',
      value: 'left',
    },
    {
      label: '居右',
      value: 'right',
    },
  ],
}

const BORDER_WIDTH_ITEM = {
  type: 'NumberInput',
  _modelKey: 'width',
  label: '边框宽度',
}

const BORDER_COLOR_ITEM = {
  type: 'ColorSet',
  _modelKey: 'color',
  label: '边框颜色',
}

const LINE_HEIGHT_ITEM = {
  type: 'NumberInput',
  _modelKey: 'line-height',
  label: '文本高度',
}

const ITEM_MAP = {
  width: WIDTH_ITEM,
  height: HEIGHT_ITEM,
  marginTop: MARGIN_TOP_ITEM,
  marginBottom: MARGIN_BOTTOM_ITEM,
  backgroundImage: BG_IMAGE_ITEM,
  backgroundColor: BG_COLOR_ITEM,
  borderRadius: BORDER_RADIUS_ITEM,
  color: COLOR_ITEM,
  top: TOP_ITEM,
  fontSize: FONT_SIZE_ITEM,
  textAlign: TEXT_ALIGN_ITEM,
  borderWidth: BORDER_WIDTH_ITEM,
  borderColor: BORDER_COLOR_ITEM,
  lineHeight: LINE_HEIGHT_ITEM,
}
class Form {
  getTrigger(modelKey, val) {
    return [
      {
        key: modelKey,
        val: val,
        save: false,
      },
    ]
  }

  getImageItem(label, modelKey, option = {}) {
    return {
      label,
      type: 'MediaInput',
      modelKey,
      mediaType: 'img',
      clearable: true,
      needFileName: false,
      condition: option.condition,
      ...option.setting,
    }
  }

  getStyleItems(label, modelKey, option = {}) {
    return this._createItems(label, modelKey, option)
  }

  getTextItem(label, modelKey, option = {}) {
    const item = {
      label,
      type: 'Input',
      modelKey,
      ...option.setting,
    }
    if (option.condition) {
      item.condition = Array.isArray(option.condition)
        ? option.condition
        : [option.condition]
    }
    return item
  }

  getNumberItem(label, modelKey, option = {}) {
    return {
      label,
      type: 'NumberInput',
      modelKey,
      condition: Array.isArray(option.condition)
        ? option.condition
        : [option.condition],
      ...option.setting,
    }
  }

  getSwitchItem(label, modelKey, option = {}) {
    return {
      label,
      type: 'Switch',
      modelKey,
      condition: Array.isArray(option.condition)
        ? option.condition
        : [option.condition],
      ...option.setting,
    }
  }

  getRadioGroupItem(label, modelKey, option = {}) {
    return {
      label,
      type: 'RadioGroup',
      modelKey,
      condition: Array.isArray(option.condition)
        ? option.condition
        : [option.condition],
      ...option.setting,
    }
  }

  _createItems(label, modelKey, option = {}) {
    const items = []
    if (typeof option !== 'object') {
      return items
    }
    for (const key in option) {
      const item = ITEM_MAP[key]
      item &&
        items.push(
          this._createItem(key, label, modelKey, {
            ...item,
            ...option.setting,
            ...(typeof option[key] === 'object' ? option[key] : {}),
          })
        )
    }
    return items
  }

  _createItem(key, label, modelKey, item) {
    return {
      ...item,
      label: item.label ? `${label} ${item.label}` : '',
      modelKey: `${modelKey}.${key}`,
    }
  }
}

export function rpx(rpx) {
  if (typeof rpx === 'number') {
    rpx = `${rpx}rpx`
  }
  const designWidth = 750
  let ratio = `${100 / designWidth}`
  let unit = 'vw'
  if (process.env.MODE === 'editor') {
    ratio = 0.5
    unit = 'px'
  }
  return rpx.replace(/(\d*\.?\d+)rpx([\s;,)}]|$)/g, function (...arg) {
    return `${arg[1] * ratio}${unit}${arg[2]}`
  })
}

export default class LaunchForm extends Form {
  constructor(options = {}) {
    super()
    this.options = options
  }

  getPageTrigger(pageName) {
    const pages = this.options.pages[pageName] || {}
    const items = []
    for (const key in pages) {
      items.push({
        key: key,
        val: pages[key],
        save: false,
      })
    }
    return items
  }
}

const getStyleStrategy = [
  {
    test: (key, style) => typeof style[key] === 'number',
    handler: (key, style) => {
      style[key] = rpx(`${style[key]}rpx`)
    },
  },
  {
    test: (key, style) => {
      const isPic = /https:\/\/.*?(\.png|.jpe?g|\.webp)/.test(style[key])
      const needHandler = !/url\(.*?\)/.test(style[key])
      return isPic && needHandler
    },
    handler: (key, style) => {
      style[key] = `url('${utils.webpUrl(style[key])}')`
    },
  },
  {
    test: (key, style) => key === 'borderWidth',
    handler: (key, style) => {
      style.borderStyle = 'solid'
    },
  },
]

export function getStyle(style) {
  if (!style) return {}
  for (const key in style) {
    getStyleStrategy.forEach(strategy => {
      strategy.test(key, style) && strategy.handler(key, style)
    })
  }
  return style
}
